import { EyeInvisibleOutlined } from '@ant-design/icons'
import { Localizable } from '@components/localizable/Localizable'
import { VenuesCollection as VenuesCollectionModel } from '@models/VenuesCollection'
import { useAppSelector } from '@store/hooks'
import { selectVenuesByIds } from '@store/VenueReducer'
import { selectVenuesCollectionById } from '@store/VenuesCollectionReducer'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { SBRM, SBRMAction } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { Flex, Tag, Tooltip, Typography } from 'antd'

const { Text } = Typography

type Props = SBModelComponent<VenuesCollectionModel> & {}
const VenuesCollectionCardHeader = ({ id, model }: Props) => {
  const item = model ?? useAppSelector(selectVenuesCollectionById(id!))

  const venues = useAppSelector(selectVenuesByIds(item?.venues || []))

  if (!item) {
    return <></>
  }
  return (
    <Flex justify="space-between" align="center">
      <Flex align="center" gap={8}>
        <Localizable.Render
          item={item}
          render={(localizedItem) => <Text>{localizedItem.title}</Text>}
        />
      </Flex>
      <Flex align="center" gap={16}>
        {venues
          .filter((venue) => item.venues.includes(venue.id))
          .every((venue) => venue.visibility.application === 'hidden') && (
          <Tooltip title="This collection is currently hidden because all of its associated venues are hidden.">
            <Tag color="orange" icon={<EyeInvisibleOutlined />}>
              Hidden
            </Tag>
          </Tooltip>
        )}
        <SBRM.Actions
          actions={[SBRMAction.Update, SBRMAction.Delete]}
          entity={Entity.venuesCollection}
          entityId={item.id}
        />
      </Flex>
    </Flex>
  )
}

type VenuesCollectionCardHeaderType = {
  Header: typeof VenuesCollectionCardHeader
}

export { VenuesCollectionCardHeader, type VenuesCollectionCardHeaderType }
